import { RefObject, useEffect, useRef } from 'react';

import { DebounceTextFieldHandle } from '@uiKit/DebounceTextField';

type UseCardScannerOptions = {
  searchText?: string;
  searchRef: RefObject<DebounceTextFieldHandle | null>;
};

const timeout = 1000;

export const useCardScanner = ({ searchText = '', searchRef }: UseCardScannerOptions) => {
  const searchTextRef = useRef(searchText);
  const lastEventTimeRef = useRef<number | null>(null);

  useEffect(() => {
    searchTextRef.current = searchText;
  }, [searchText]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.code === '' && event.key !== 'Enter') {
        event.preventDefault();

        const currentTime = Date.now();
        const timeSinceLastEvent = lastEventTimeRef.current !== null ? currentTime - lastEventTimeRef.current : null;
        const shouldClear =
          (timeSinceLastEvent !== null && timeSinceLastEvent > timeout) ||
          (timeSinceLastEvent === null && searchTextRef.current !== '');

        if (shouldClear) {
          searchTextRef.current = '';
          searchRef.current?.resetDebouncedTextFieldValue?.();
          searchRef.current?.setValue(event.key);
          // Update ref to match the new value immediately
          searchTextRef.current = event.key;
        } else {
          const newValue = searchTextRef.current + event.key;
          searchRef.current?.setValue(newValue);
          // Update ref to match the new value immediately
          searchTextRef.current = newValue;
        }

        lastEventTimeRef.current = currentTime;
      }
    };

    window.addEventListener('keypress', handleKeyPress);

    return () => {
      window.removeEventListener('keypress', handleKeyPress);
    };
  }, [searchRef]);
};
